/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useEffect, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';

import { ToolsModal } from '../ToolsModal';
import { hex2rgba } from '../../helpers/shared';
import { UserContext } from '../../context/userContext';
import { IBrushFields } from '../../@types/generated/contentful';

type Props = {
  size: 'large' | 'small';
  set: IBrushFields;
  category: string;
  isFeatured?: boolean;
  isBrushset?: boolean;
};

const ToolCard = ({ size, isBrushset, category, isFeatured, set }: Props) => {
  const [isToolModalOpen, setToolModalOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const { user } = useContext(UserContext);
  const { hasPremium = false } = user || {};

  const { color, fontColor, image, section: brushes, title } = set;

  const handleClick = () => {
    setToolModalOpen(true);
    setSearchParams({ tool: title ? title.replace(/\s/g, '_') : '' });
    mixpanel.track('Set Selected', { premium: hasPremium, set: title, category, featured: isFeatured });
  };

  const handleModalClose = () => {
    setToolModalOpen(false);
    searchParams.delete('tool');
    setSearchParams(searchParams);
  };

  useEffect(() => {
    if (title && searchParams.get('tool') === title.replace(/\s/g, '_')) {
      setToolModalOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`
  rounded-[12px] 
  flex
  flex-col
  bg-center
  bg-cover
  cursor-pointer
  relative
  overflow-hidden
  justify-end
  ${
    size === 'large'
      ? 'w-[225px] h-[225px] sm:w-[204px] sm:h-[204px] xs:w-[170px] xs:h-[170px] xxs:w-[225px] xxs:h-[225px]'
      : 'w-[200px] h-[200px] sm:w-[180px] sm:h-[180px] xs:w-[170px] xs:h-[170px]'
  }
  `}
      onClick={handleClick}
      style={{ backgroundColor: color, outline: 'none' }}
    >
      <img
        src={`http:${image?.fields.file.url}`}
        alt='brush'
        className='absolute z-[0] -translate-x-[50%] -translate-y-[50%] left-1/2 top-1/2 select-none max-h-full'
        loading='lazy'
      />
      <div
        className={`self-start 
        z-[2] pb-5 pl-5 rounded-[12px] w-full h-[45%] flex flex-col justify-end items-start`}
        style={{
          backgroundImage: `linear-gradient(to top, ${color} 40%, ${hex2rgba(color || '#ffffff', 0)} 100%)`,
          color: fontColor,
        }}
      >
        <h3 className='text-2xl leading-2xl xs:leading-lg xs:text-lg font-bold'>{title}</h3>
        {isBrushset && brushes && (
          <p className='text-xxs leading-xxs'>
            {brushes.length} {brushes.length > 1 ? 'brushes' : 'brush'}
          </p>
        )}
      </div>
      <ToolsModal isOpen={isToolModalOpen} onClose={handleModalClose} set={set} isBrushset={isBrushset} />
    </div>
  );
};

export { ToolCard };
